import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthStore } from './auth.store';

export const authGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Wait for auth to be initialized if not already
  if (!authStore.initialized()) {
    await waitForInitialization(authStore);
  }

  if (authStore.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/auth/login']);
};

export const publicOnlyGuard: CanActivateFn = async () => {
  const authStore = inject(AuthStore);
  const router = inject(Router);

  // Wait for auth to be initialized if not already
  if (!authStore.initialized()) {
    await waitForInitialization(authStore);
  }

  if (!authStore.isAuthenticated()) {
    return true;
  }

  if (authStore.isPlatformAdmin()) {
    return router.createUrlTree(['/platform/tenants']);
  }

  return router.createUrlTree(['/dashboard']);
};

function waitForInitialization(authStore: AuthStore): Promise<void> {
  return new Promise((resolve) => {
    const checkInit = () => {
      if (authStore.initialized()) {
        resolve();
      } else {
        setTimeout(checkInit, 50);
      }
    };
    checkInit();
  });
}
